import { render } from "./SocioeconomicStudyPanel.vue?vue&type=template&id=4eabd71a"
import script from "./SocioeconomicStudyPanel.vue?vue&type=script&lang=js"
export * from "./SocioeconomicStudyPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/home/Documents/kevin/matrix_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__